var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),(_vm.type_button)?_c('b-button',{attrs:{"variant":_vm.type_button},domProps:{"innerHTML":_vm._s(_vm.text_button)},on:{"click":_vm.action}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }